// src/App.js
import React from 'react';
import CustomerTable from './CustomerTable';
import './App.css';

function App() {
  return (
    <div className="App">
      <CustomerTable />
    </div>
  );
}

export default App;
